import { fetchApi } from '@vend/utilities'
import { SwiperError, SwiperErrorResponse } from './lspay.types'
export interface CNPConfig {
  currency: string
  client_key: string
}

export const fetchCNPConfig = async (outletId: string): Promise<CNPConfig> => {
  const response = await fetchApi(`/api/2.0/lspay/cnp_config/${outletId}`)

  if (response.status < 200 || response.status > 299) {
    const swiperError: SwiperErrorResponse = await response.json()

    throw new SwiperError(
      swiperError.error,
      swiperError.code,
      swiperError.fields
    )
  }

  return response.json()
}
